/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetEventsDto interface.
 */
export function instanceOfGetEventsDto(value) {
    return true;
}
export function GetEventsDtoFromJSON(json) {
    return GetEventsDtoFromJSONTyped(json, false);
}
export function GetEventsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}
export function GetEventsDtoToJSON(json) {
    return GetEventsDtoToJSONTyped(json, false);
}
export function GetEventsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}
